import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ControlsCartComponent } from './controls-cart.component';

const routes: Routes = [{ path: '', component: ControlsCartComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ControlsCartRoutingModule { }
